import { useState } from "react";
import GradePopup from "./RecommenderPage/GradePopup";

interface FinishedControlSurveyProps {
  submittingGrade: boolean;
  gradePosted: boolean;
}

function DismissibleGradePopup({
  submittingGrade,
}: {
  submittingGrade: boolean;
}) {
  const [open, setOpen] = useState(true);

  if (!open) return null;

  return (
    <GradePopup
      onDismiss={() => {
        setOpen(false);
      }}
      submittingGrade={submittingGrade}
    />
  );
}

export function FinishedControlSurvey({
  submittingGrade,
  gradePosted,
}: FinishedControlSurveyProps) {
  const popupPhase = submittingGrade
    ? "submitting"
    : gradePosted
      ? "posted"
      : null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      {!popupPhase && (
        <h1>Thank you for participating! You may now close this window.</h1>
      )}

      {popupPhase && (
        <DismissibleGradePopup
          key={popupPhase}
          submittingGrade={submittingGrade}
        />
      )}
    </div>
  );
}
